module.exports = "<span class=\"sequence-warning\">\n  <svg aria-hidden=\"true\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    <path d=\"M15 4.41 13.59 3 9 7.59 4.41 3 3 4.41 7.59 9 3 13.59 4.41 15 9 10.41 13.59 15 15 13.59 10.41 9 15 4.41Z\"></path>\n  </svg>\n  {{ data }}\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/snackbars/snackbar-warning/snackbar-warning.component.html
// module id = ./src/app/shared/snackbars/snackbar-warning/snackbar-warning.component.html
// module chunks = main